import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * telチェッククラス
 */
export default class EFOcats_validate_tel extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (checkData.attr('type') !== 'tel') {
      return new EFOcats_error_info('success', '', '', '');
    }

    const material_dataType = checkData.attr('data-type');
    let result;

    if (material_dataType === 'postal') {
      result = this.check_postal(checkData);
    } else if (material_dataType === 'birthday') {
      result = this.check_birthday(checkData);
    } else {
      result = this.check_tel(checkData);
    }

    return result;
  }

  /**
   * 電話番号チェック
   */
  check_tel(checkData) {
    const material_val = checkData.val();
    let result = new EFOcats_error_info('success', '', '', '');

    if (material_val.match(/^(0[5-9]0[0-9]{8}||0[1-9][1-9][0-9]{7})$/)) {
      result = new EFOcats_error_info('success', '', '', '');
    } else if (material_val.match(/^[0-9]+$/)) {
      result = new EFOcats_error_info('error', this.langagerList('電話番号エラー'), '', '電話番号エラー');
    } else {
      result = new EFOcats_error_info('error', this.langagerList('半角エラー'), '', '半角エラー');
    }

    const mobile_prefix = ['050', '060', '070', '080', '090'];

    if (mobile_prefix.includes(checkData.val().substr(0, 3)) && checkData.val().length !== 11) {
      // 最初が050～090で11桁ではない
      result = new EFOcats_error_info('error', this.langagerList('電話番号桁エラー'), '', '電話番号桁エラー');
    } else if (!mobile_prefix.includes(checkData.val().substr(0, 3)) && checkData.val().length !== 10) {
      // 最初が050～090ではなく10桁ではない
      result = new EFOcats_error_info('error', this.langagerList('電話番号桁エラー'), '', '電話番号桁エラー');
    }

    return result;
  }

  /**
   * 生年月日チェック
   */
  check_birthday(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');
    this.rep_birthday(checkData);
    const split_val = checkData.val().split('/');
    const num_extraction_pattern = new RegExp(/[1-9１-９]/);
    if (checkData.val().match(num_extraction_pattern)) {
      // 存在しない日付を入れた場合はエラーにする
      if (split_val[1] <= 0 || split_val[1] > 12 || split_val[2] <= 0 || split_val[2] > 31) {
        result = new EFOcats_error_info('error', this.langagerList('生年月日エラー'), '', '生年月日エラー');
      }
    } else {
      result = new EFOcats_error_info('error', this.langagerList('生年月日エラー'), '', '生年月日エラー');
    }
    return result;
  }

  /**
   * 郵便番号チェック
   */
  check_postal(checkData) {
    const material_val = checkData.val();
    let result = new EFOcats_error_info('success', '', '', '');

    if (material_val.match(/^\d{3}-?\d{4}$/)) {
      result = new EFOcats_error_info('success', '', '', '');
    } else {
      result = new EFOcats_error_info('error', this.langagerList('郵便1エラー'), '', '郵便1エラー');
    }
    return result;
  }

  /**
   * 文字の挿入
   */
  strIns(str, idx, val) {
    const res = str.slice(0, idx) + val + str.slice(idx);
    return res;
  }
}
